module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "x-filter-modal",
    attrs: {
      "open": _vm.open,
      "saveText": _vm.$t('ui.xfilters.add_filter_confirm'),
      "cancelText": null,
      "clickOutsideClose": true
    },
    on: {
      "cancel": _vm.closeModal,
      "save": _vm.addCondition
    }
  }, [_c('span', {
    staticClass: "x-filter-modal-label"
  }, [_vm._v("\n    " + _vm._s(_vm.filterDefinition.label) + "\n  ")]), _vm._v(" "), (Array.isArray(_vm.filterDefinition.predicate)) ? _c('span', {
    staticClass: "x-filter-modal-predicates"
  }, _vm._l((_vm.filterDefinition.predicate), function(predName, index) {
    return _c('q-radio', {
      key: index,
      staticClass: "x-filter-modal-predicate-item",
      attrs: {
        "val": predName,
        "label": _vm.$t('ui.xfilters.conditions.predicates.' + predName),
        "disable": _vm.hasNone
      },
      model: {
        value: (_vm.data.predicate),
        callback: function($$v) {
          _vm.$set(_vm.data, "predicate", $$v)
        },
        expression: "data.predicate"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.type == 'text') ? _c('span', {
    staticClass: "x-filter-modal-text"
  }, [(_vm.filterDefinition.auto_complete) ? _c('auto-complete', {
    staticClass: "x-filter-modal-autocomplete",
    attrs: {
      "model": _vm.filterDefinition.auto_complete,
      "type": "text",
      "label": "empty",
      "name": "value",
      "item": _vm.data,
      "init": "none",
      "disabled": _vm.hasNone,
      "autofocus": true,
      "acMinCharacters": 3
    },
    on: {
      "change": _vm.autoSelect
    }
  }) : _c('field', {
    attrs: {
      "disabled": _vm.hasNone,
      "autofocus": true
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.type == 'set') ? _c('span', {
    staticClass: "x-filter-modal-set"
  }, [(_vm.filterDefinition.predicate == 'eq') ? _c('span', [(_vm.filterDefinition.method == 'select') ? _c('span', [_c('field', {
    attrs: {
      "type": "select",
      "collection": _vm.filterDefinition.options,
      "disabled": _vm.hasNone,
      "autofocus": true
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1) : (_vm.filterDefinition.attribute == 'country') ? _c('span', [_c('country-select', {
    attrs: {
      "disabled": _vm.hasNone,
      "autofocus": true,
      "language": _vm.$store.getters.getCurrentLanguage,
      "params": {
        favorites: ['DE']
      }
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1) : _c('span', _vm._l((_vm.filterDefinition.options), function(option, index) {
    return _c('q-radio', {
      key: index,
      attrs: {
        "val": option.value,
        "label": option.name,
        "disable": _vm.hasNone
      },
      model: {
        value: (_vm.data.value),
        callback: function($$v) {
          _vm.$set(_vm.data, "value", $$v)
        },
        expression: "data.value"
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.method == 'chips') ? _c('span', {
    staticClass: "x-filter-modal-chips"
  }, [_c('q-field', [_c('q-chips-input', {
    attrs: {
      "disable": _vm.hasNone,
      "autofocus": true,
      "hide-underline": "",
      "close-icon": "close"
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (['in', 'has_any', 'has_all'].includes(_vm.filterDefinition.predicate)) ? _c('span', _vm._l((_vm.filterDefinition.options), function(option, index) {
    return _c('q-checkbox', {
      key: index,
      staticClass: "x-filter-modal-checkbox",
      attrs: {
        "val": option.value,
        "label": option.name,
        "disable": _vm.hasNone
      },
      model: {
        value: (_vm.data.value),
        callback: function($$v) {
          _vm.$set(_vm.data, "value", $$v)
        },
        expression: "data.value"
      }
    })
  }), 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.type == 'date') ? _c('span', {
    staticClass: "x-filter-modal-date field"
  }, [(this.enableRelativeRanges()) ? _c('field', {
    attrs: {
      "type": "select",
      "collection": _vm.filterDefinition.options,
      "autofocus": true
    },
    on: {
      "input": _vm.dateRangeChange
    },
    model: {
      value: (_vm.data.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.data, "dateRange", $$v)
      },
      expression: "data.dateRange"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('ui.xfilters.xfiltermodal.date_from')))]), _vm._v(" "), _c('datepicker', {
    key: 'from' + _vm.key,
    attrs: {
      "clear-button": true,
      "full-month-name": true,
      "format": "d MMMM, yyyy",
      "disabled-dates": {
        from: _vm.data.value2
      },
      "language": _vm.getDatePickerLanguage()
    },
    on: {
      "input": _vm.dateChanged
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('ui.xfilters.xfiltermodal.date_to')))]), _vm._v(" "), _c('datepicker', {
    key: 'to' + _vm.key,
    attrs: {
      "clear-button": true,
      "full-month-name": true,
      "format": "d MMMM, yyyy",
      "disabled-dates": {
        to: _vm.data.value
      },
      "language": _vm.getDatePickerLanguage()
    },
    on: {
      "input": _vm.dateChanged
    },
    model: {
      value: (_vm.data.value2),
      callback: function($$v) {
        _vm.$set(_vm.data, "value2", $$v)
      },
      expression: "data.value2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.include_none != null) ? _c('span', {
    staticClass: "x-filter-modal-has-none"
  }, [_c('q-checkbox', {
    staticClass: "x-filter-modal-checkbox",
    attrs: {
      "color": "primary",
      "label": _vm.filterDefinition.include_none
    },
    model: {
      value: (_vm.hasNone),
      callback: function($$v) {
        _vm.hasNone = $$v
      },
      expression: "hasNone"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d0bd9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/XFilterModal.vue
// module id = 1945
// module chunks = 0